import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import InvoiceServices from "../based/services/InvoiceServices";
import Common from "../based/Common";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";
import { InvoiceReasonModify } from "./InvoiceReasonModal";
import TextNumber from "../based/inputs/TextNumber";
import { ConfirmDialog } from "../based/Dialog";

const InvoiceMode = {
    Original: 1,
    Adjust_Replace: 2,
};

const ModeAreaType = {
    companyName: 1,
    taxCode: 2,
    email: 3,
    address: 4,
    invoiceInfoHistoryDetails: 5,
    taxPercentage: 6,
};

function InvoiceManagementEditModal({ show, onClose, originalInvoiceId, onSuceed, reasonId }) {
    const [model, setModel] = useState({});
    const [busy, setBusy] = useState(false);

    const editMode = useMemo(() => {
        if (reasonId == 0 || reasonId == null) return InvoiceMode.Original;
        return InvoiceMode.Adjust_Replace;
    }, [reasonId]);

    useEffect(() => {
        if (originalInvoiceId && show) {
            getData(originalInvoiceId);
        }
    }, [originalInvoiceId, show]);

    const disableMode = useMemo(() => {
        //nếu editmode là original thì return false
        if (editMode === InvoiceMode.Original) return Object.values(ModeAreaType);

        switch (reasonId) {
            case InvoiceReasonModify.WrongCompanyNameAddress:
                return [ModeAreaType.companyName, ModeAreaType.address];
            case InvoiceReasonModify.AdjustTaxCode:
                return [ModeAreaType.taxCode];
            case InvoiceReasonModify.AdjustProductInfo:
                return [ModeAreaType.invoiceInfoHistoryDetails];
            case InvoiceReasonModify.AdjustTaxRate:
                return [ModeAreaType.taxPercentage];
            case InvoiceReasonModify.AdjustInvoiceValue_FullReturn:
                return [ModeAreaType.invoiceInfoHistoryDetails];
            case InvoiceReasonModify.AdjustInvoiceValue_PartialReturn:
                return [ModeAreaType.invoiceInfoHistoryDetails];
            case InvoiceReasonModify.Replace_WholeInvoice:
                return [];
            default:
                return Object.values(ModeAreaType);
        }
    }, [editMode, reasonId]);

    const getData = async (originalInvoiceId) => {
        setBusy(true);
        const [err, data] = await InvoiceServices.GetInfoHistoryById(originalInvoiceId);
        if (!err && data) {
            let dt = { ...data };
            dt.buyerNotGetInvoice = dt.taxCode === "" || dt.taxCode === null;
            setModel(dt);
        } else {
            setModel({});
        }
        setBusy(false);
    };

    const handleSave = async () => {
        setBusy(true);
        const [err, data] = await InvoiceServices.UpdateInfoHistory(model);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thông tin thành công");
            onSuceed();
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thông tin thất bại");
        }
        setBusy(false);
    };

    const handleModifyInvoice = async () => {
        setBusy(true);
        const [err, data] = await InvoiceServices.ModifyInvoice(model, reasonId);
        if (!err && data) {
            let res = await publishInvoice(data);
            if (res) {
                onSuceed();
                return true;
            } else return false;
        }
        setBusy(false);
        return false;
    };

    const publishInvoice = async (originalInvoiceId) => {
        setBusy(true);
        const [err, data] = await InvoiceServices.PublishInvoice(originalInvoiceId);
        if (!err && data) {
            return true;
        } else {
            return false;
        }
    };

    if (model === null) return null;
    return (
        <CommonModal busyMsg={"Đang xử lý"} isBusy={busy} show={show} onClose={onClose} title={editMode === InvoiceMode.Adjust_Replace ? "Hiệu chỉnh/Thay thế hóa đơn" : "Chỉnh sửa thông tin hóa đơn"} hideOnClose size="lg">
            <Wrapper>
                <div className="not-get-invoice">
                    <input
                        type="checkbox"
                        className="check-box"
                        id="not-get-invoice"
                        name="not-get-invoice"
                        checked={model.buyerNotGetInvoice}
                        onChange={(e) => {
                            setModel({ ...model, buyerNotGetInvoice: e.target.checked });
                        }}
                    />
                    <label htmlFor="not-get-invoice">KHÁCH KHÔNG LẤY HÓA ĐƠN</label>
                </div>
                {!model.buyerNotGetInvoice && (
                    <div className="edit_invoice_content">
                        {/* <div className="edit_invoice_content-search">
                        <label htmlFor="">Tìm kiếm</label>
                        <div className="input-search-box">
                            <input type="text" />
                            <button className="btn btn-search">Tìm kiếm</button>
                        </div>
                    </div> */}
                        <div className="edit_invoice_content-name">
                            <label htmlFor="">Tên đơn vị</label>
                            <div className="input-address-box">
                                <input
                                    type="text"
                                    value={model.companyName}
                                    onChange={(e) => {
                                        let val = e.target.value;
                                        setModel({ ...model, companyName: val });
                                    }}
                                    readOnly={!disableMode.includes(ModeAreaType.companyName)}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="edit_invoice_content-mst-email">
                            <div className="edit_invoice_content-mst">
                                <label htmlFor="">Mã số thuế</label>
                                <div className="input-mst">
                                    <input
                                        type="text"
                                        value={model.taxCode}
                                        onChange={(e) => {
                                            let val = e.target.value;
                                            setModel({ ...model, taxCode: val });
                                        }}
                                        readOnly={!disableMode.includes(ModeAreaType.taxCode)}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                            <div className="edit_invoice_content-email">
                                <label htmlFor="">Email</label>
                                <div className="input-email">
                                    <input
                                        type="text"
                                        value={model.email}
                                        onChange={(e) => {
                                            let val = e.target.value;
                                            setModel({ ...model, email: val });
                                        }}
                                        readOnly={!disableMode.includes(ModeAreaType.email)}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="edit_invoice_content-address">
                            <label htmlFor="">Địa chỉ</label>
                            <div className="input-address">
                                <input
                                    type="text"
                                    value={model.address}
                                    onChange={(e) => {
                                        let val = e.target.value;
                                        setModel({ ...model, address: val });
                                    }}
                                    readOnly={!disableMode.includes(ModeAreaType.address)}
                                    className="form-control"
                                />
                            </div>
                        </div>
                    </div>
                )}

                <hr />
                <div className="edit_invoice_table">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    style={{
                                        width: "10%",
                                    }}
                                >
                                    <div className="col-invoice">
                                        <main>STT</main>
                                        <sub>(No.)</sub>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div className="col-invoice">
                                        <main>Tên hàng hóa, dịch vụ</main>
                                        <sub>(Description)</sub>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    style={{
                                        width: "10%",
                                    }}
                                >
                                    <div className="col-invoice">
                                        <main>Đơn vị tính</main>
                                        <sub>(Unit)</sub>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    style={{
                                        width: "10%",
                                    }}
                                >
                                    <div className="col-invoice">
                                        <main>Số lượng</main>
                                        <sub>(Quantity)</sub>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    style={{
                                        width: "10%",
                                    }}
                                >
                                    <div className="col-invoice">
                                        <main>Đơn giá</main>
                                        <sub>(Unit Price)</sub>
                                    </div>
                                </th>
                                <th
                                    scope="col"
                                    style={{
                                        width: "10%",
                                    }}
                                >
                                    <div className="col-invoice">
                                        <main>Thành tiền</main>
                                        <sub>(Amount)</sub>
                                    </div>
                                </th>
                                <th
                                    style={{
                                        width: "10%",
                                    }}
                                ></th>
                            </tr>
                        </thead>
                        <tbody>
                            {model.invoiceInfoHistoryDetails &&
                                model.invoiceInfoHistoryDetails.map((item, idx) => {
                                    if (item.editable) {
                                        return (
                                            <tr
                                                key={idx}
                                                style={{
                                                    height: "40px",
                                                }}
                                            >
                                                <th scope="row" className="vertical-align-middle">
                                                    {idx + 1}
                                                </th>
                                                <td>
                                                    <input
                                                        type="text"
                                                        value={item.name}
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            let dt = { ...model };
                                                            let details = model.invoiceInfoHistoryDetails;
                                                            let item = details[idx];
                                                            item.name = e.target.value;
                                                            dt.invoiceInfoHistoryDetails = details;
                                                            setModel(dt);
                                                        }}
                                                    />
                                                </td>
                                                <td className="vertical-align-middle">Cái</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={item.quantity}
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            let dt = { ...model };
                                                            let details = model.invoiceInfoHistoryDetails;
                                                            let item = details[idx];
                                                            item.quantity = +e.target.value;
                                                            if (item.unitPrice) {
                                                                item.itemTotalAmountWithoutTax = item.quantity * item.unitPrice;
                                                                dt.invoiceInfoHistoryDetails = details;
                                                                dt.totalAmountWithoutTax = dt.invoiceInfoHistoryDetails.reduce((sum, curr) => sum + curr.itemTotalAmountWithoutTax, 0);
                                                                dt.taxAmount = Number((dt.totalAmountWithoutTax * dt.taxPercentage).toFixed(2));
                                                                dt.totalAmount = Number((dt.totalAmountWithoutTax + dt.taxAmount).toFixed(2));
                                                            }
                                                            setModel(dt);
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        value={item.unitPrice}
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            let dt = { ...model };
                                                            let details = model.invoiceInfoHistoryDetails;
                                                            let item = details[idx];
                                                            item.unitPrice = +e.target.value;
                                                            if (item.quantity) {
                                                                item.itemTotalAmountWithoutTax = item.quantity * item.unitPrice;
                                                                dt.invoiceInfoHistoryDetails = details;
                                                                dt.totalAmountWithoutTax = dt.invoiceInfoHistoryDetails.reduce((sum, curr) => sum + curr.itemTotalAmountWithoutTax, 0);
                                                                dt.taxAmount = Number((dt.totalAmountWithoutTax * dt.taxPercentage).toFixed(2));
                                                                dt.totalAmount = Number((dt.totalAmountWithoutTax + dt.taxAmount).toFixed(2));
                                                            }
                                                            setModel(dt);
                                                        }}
                                                    />
                                                </td>
                                                <td className="vertical-align-middle">{Common.formatCurrency(item.itemTotalAmountWithoutTax)}</td>
                                                <td className="vertical-align-middle">
                                                    <div className={!disableMode.includes(ModeAreaType.invoiceInfoHistoryDetails) ? "lst-icon disabled" : "lst-icon"}>
                                                        <a
                                                            href=""
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                let dt = { ...model };
                                                                let details = model.invoiceInfoHistoryDetails;
                                                                details.splice(idx, 1);
                                                                dt.invoiceInfoHistoryDetails = details;
                                                                dt.totalAmountWithoutTax = dt.invoiceInfoHistoryDetails.reduce((sum, curr) => sum + curr.itemTotalAmountWithoutTax, 0);
                                                                dt.taxAmount = Number((dt.totalAmountWithoutTax * (dt.taxPercentage / 100)).toFixed(2));
                                                                dt.totalAmount = Number((dt.totalAmountWithoutTax + dt.taxAmount).toFixed(2));
                                                                setModel(dt);
                                                            }}
                                                            className="m-1"
                                                        >
                                                            <i className="fa fa-trash"></i>
                                                        </a>
                                                        <a
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                let dt = { ...model };
                                                                let details = model.invoiceInfoHistoryDetails;
                                                                let item = details[idx];
                                                                item.editable = !item.editable;
                                                                dt.invoiceInfoHistoryDetails = details;
                                                                setModel(dt);
                                                            }}
                                                            className="m-1"
                                                        >
                                                            <i className="fa fa-edit"></i>
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    }
                                    return (
                                        <tr
                                            key={idx}
                                            style={{
                                                height: "40px",
                                            }}
                                        >
                                            <th scope="row" className="vertical-align-middle">
                                                {idx + 1}
                                            </th>
                                            <td className="vertical-align-middle">{item.name}</td>
                                            <td className="vertical-align-middle">Cái</td>
                                            <td className="vertical-align-middle">{item.quantity}</td>
                                            <td className="vertical-align-middle">{Common.formatCurrency(item.unitPrice)}</td>
                                            <td className="vertical-align-middle">{Common.formatCurrency(item.itemTotalAmountWithoutTax)}</td>
                                            <td className="vertical-align-middle">
                                                <div className={!disableMode.includes(ModeAreaType.invoiceInfoHistoryDetails) ? "lst-icon disabled" : "lst-icon"}>
                                                    <a
                                                        href=""
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            let dt = { ...model };
                                                            let details = model.invoiceInfoHistoryDetails;
                                                            details.splice(idx, 1);
                                                            dt.invoiceInfoHistoryDetails = details;
                                                            dt.totalAmountWithoutTax = dt.invoiceInfoHistoryDetails.reduce((sum, curr) => sum + curr.itemTotalAmountWithoutTax, 0);
                                                            dt.taxAmount = Number((dt.totalAmountWithoutTax * dt.taxPercentage).toFixed(2));
                                                            dt.totalAmount = Number((dt.totalAmountWithoutTax + dt.taxAmount).toFixed(2));
                                                            setModel(dt);
                                                        }}
                                                        className="m-1"
                                                    >
                                                        <i className="fa fa-trash"></i>
                                                    </a>
                                                    <a
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            let dt = { ...model };
                                                            let details = model.invoiceInfoHistoryDetails;
                                                            let item = details[idx];
                                                            item.editable = !item.editable;
                                                            dt.invoiceInfoHistoryDetails = details;
                                                            setModel(dt);
                                                        }}
                                                        className="m-1"
                                                    >
                                                        <i className="fa fa-edit"></i>
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                    <div className="edit_invoice_table-bottom">
                        <div className="edit_invoice_table-bottom-left">
                            <div
                                className={!disableMode.includes(ModeAreaType.invoiceInfoHistoryDetails) ? "add-row disabled" : "add-row"}
                                onClick={(e) => {
                                    let dt = { ...model };
                                    dt.invoiceInfoHistoryDetails.push({ editable: true });
                                    setModel(dt);
                                }}
                            >
                                <span>Thêm sản phẩm + </span>
                            </div>
                        </div>
                        <div className="edit_invoice_table-bottom-right">
                            <div className="edit_invoice_table-bottom-right-line">
                                <div className="edit_invoice_table-bottom-right-line-name">
                                    <span>Cộng tiền hàng</span>
                                </div>
                                <div className="edit_invoice_table-bottom-right-line-amount">
                                    <span>{Common.formatCurrency(model.totalAmountWithoutTax)}</span>
                                </div>
                            </div>
                            <div className="edit_invoice_table-bottom-right-line">
                                <div className="edit_invoice_table-bottom-right-line-name">
                                    <span>Thuế suất GTGT</span>
                                </div>
                                <div className="edit_invoice_table-bottom-right-line-amount d-flex align-center">
                                    <TextNumber
                                        name="edit_tax_percentage"
                                        value={model.taxPercentage * 100}
                                        onChanged={(name, value) => {
                                            let newTaxPercentage = +value / 100;
                                            let dt = { ...model };
                                            dt.taxPercentage = newTaxPercentage;
                                            dt.totalAmountWithoutTax = dt.invoiceInfoHistoryDetails.reduce((sum, curr) => sum + curr.itemTotalAmountWithoutTax, 0);
                                            dt.taxAmount = Number((dt.totalAmountWithoutTax * dt.taxPercentage).toFixed(2));
                                            dt.totalAmount = Number((dt.totalAmountWithoutTax + dt.taxAmount).toFixed(2));
                                            setModel(dt);
                                        }}
                                        readOnly={!disableMode.includes(ModeAreaType.taxPercentage)}
                                        className="align-right"
                                    />
                                    <span className="d-flex align-items-center">%</span>
                                </div>
                            </div>
                            <div className="edit_invoice_table-bottom-right-line">
                                <div className="edit_invoice_table-bottom-right-line-name">
                                    <span>Tiền thuế GTGT</span>
                                </div>
                                <div className="edit_invoice_table-bottom-right-line-amount">
                                    <span>{Common.formatCurrency(model.taxAmount)}</span>
                                </div>
                            </div>
                            <div className="edit_invoice_table-bottom-right-line">
                                <div className="edit_invoice_table-bottom-right-line-name">
                                    <span>TỔNG CỘNG TIỀN THANH TOÁN</span>
                                </div>
                                <div className="edit_invoice_table-bottom-right-line-amount">
                                    <main>{Common.formatCurrency(model.totalAmount)}</main>
                                </div>
                            </div>
                            {/* <div className="edit_invoice_table-bottom-right-line box">
                                <div className="edit_invoice_table-bottom-right-line-name">
                                    <span>Số tiền khách thanh toán</span>
                                </div>
                                <div className="edit_invoice_table-bottom-right-line-amount">
                                    <main>{model.totalAmount}</main>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="edit_invoice_button">
                    <div className="lst-button">
                        <button
                            className="btn btn-danger"
                            onClick={(e) => {
                                e.preventDefault();
                                onClose();
                            }}
                        >
                            Hủy
                        </button>
                        <button
                            className="btn btn-custom"
                            onClick={(e) => {
                                e.preventDefault();
                                if (editMode === InvoiceMode.Adjust_Replace) {
                                    new ConfirmDialog("Xác nhận xuất hóa đơn điều chỉnh/thay thế", "Bạn có chắc chắn muốn xuất hóa đơn điều chỉnh/thay thế không?", () => {
                                        return new Promise(async (resolve, reject) => {
                                            handleModifyInvoice().then((res) => {
                                                if (res) resolve({ title: "Thành công", msg: "Tạo thành công." });
                                                else reject({ title: "Thất bại", msg: "Tạo thất bại." });
                                            });
                                        });
                                    });
                                } else handleSave();
                            }}
                        >
                            {editMode == InvoiceMode.Adjust_Replace ? "Xuất hóa đơn điều chỉnh" : "Lưu thông tin"}
                        </button>
                    </div>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default InvoiceManagementEditModal;

const Wrapper = styled.div`
    .form-control {
        border-bottom: 1px solid #d9d9d9 !important;
        border: none;
    }

    .not-get-invoice {
        display: flex;
        align-items: center;
    }

    .not-get-invoice label {
        margin: 0 0 0 4px;
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .edit_invoice_content-search label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .input-search-box {
        display: flex;
        align-items: center;
        height: 32px;
    }

    .input-search-box input {
        flex: 1;
        height: 100%;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    .input-search-box button {
        height: 100%;
        margin-left: 12px;
    }

    .edit_invoice_content-search {
        margin: 12px 0;
    }

    .edit_invoice_content-name {
        margin: 12px 0;
    }

    .edit_invoice_content-mst-email {
        margin: 12px 0;
    }

    .edit_invoice_content-address {
        margin: 12px 0;
    }

    .edit_invoice_content-bank-info {
        margin: 12px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .edit_invoice_content label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .edit_invoice_content input[type="text"] {
        flex: 1;
        width: 100%;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        height: 32px;
    }

    .bank-number {
        width: 45%;
    }

    .bank-name {
        width: 45%;
    }

    .col-invoice {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: center;
    }

    .col-invoice main {
        color: #444;
        text-align: center;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .col-invoice sub {
        color: #848484;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    thead tr th {
        border-radius: 2px 2px 0 0;
        border: 1px solid #a0a0a0;
        background: #ededed;
    }

    .edit_invoice_table-bottom {
        display: flex;
    }

    .edit_invoice_table-bottom-right {
        margin-left: auto;
        width: 30%;
    }

    .add-row span {
        color: #64c5b1;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        cursor: pointer;
    }

    .edit_invoice_table-bottom-right-line {
        display: flex;
        align-items: center;
        margin: 8px 0px;
    }

    .edit_invoice_table-bottom-right-line-amount {
        margin-left: auto;
    }

    .edit_invoice_table-bottom-right-line-name {
        width: 60%;
        text-align: right;
        color: #444;
        text-align: right;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .edit_invoice_table-bottom-right-line-amount span {
        color: #444;
        text-align: right;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .edit_invoice_table-bottom-right-line-amount main {
        color: #444;
        text-align: right;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .edit_invoice_table-bottom-right-line.box {
        background: #cdffdf;
        padding: 12px;
    }

    .edit_invoice_table-bottom-right-line.box .edit_invoice_table-bottom-right-line-name span {
        font-weight: 400;
    }

    .lst-button {
        display: flex;
        margin-left: auto;
        gap: 16px;
    }

    .edit_invoice_button {
        display: flex;
    }

    .lst-button button {
        width: 160px;
    }
`;
